var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrgGroup = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.72,
    viewBox: "0 0 18 17.72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(353.94 62.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-337.96-49.97v-2.89h-6.44v-1.77h3.48v-7.89h-8.07v7.89h3.48v1.77h-6.4v2.89h-2.03v5.17h5.17v-5.17h-2.02v-1.77h5.28v1.77h-2.05v5.17h5.17v-5.17h-2.01v-1.77h5.32v1.77h-2.02v5.17h5.16v-5.17Zm-11.92,1.11v2.94h-2.94v-2.94Zm6.38,0v2.94h-2.94v-2.94Zm-4.37-6.89V-61.4h5.83v5.65Zm10.82,9.83h-2.94v-2.94h2.94Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrgGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/org-group.4d0f09eb7ecebc9c71b907e761ff3ce9.svg";